// lib
import React, { memo } from 'react';

// layout components
import MobileWidgetFeed from 'shared/layouts/DetailsPage/components/Widgets/components/WidgetFeed/Mobile';
import RenderBasicSlider from 'shared/layouts/DetailsPage/components/Widgets/components/RenderBasicSlider';

// styles
import { WidgetTopDesktopRef, WidgetTopMobileRef } from './styles';

// defs
import { IWidgetLayout, IWidgetData } from 'shared/layouts/DetailsPage/components/Widgets/types';

// constants
import { WIDGET_TYPES } from 'shared/layouts/DetailsPage/components/Widgets/constant';

interface ISingleWidgetProps {
  widgetType: string;
  widgetData: IWidgetData;
  index: number;
  isMobile?: boolean;
  widgetLayout?: IWidgetLayout;
  isSimilarProductsOnTop?: boolean;
  showTopBorder?: boolean;
}

function SingleWidget({
  widgetType,
  widgetData,
  index,
  isMobile,
  widgetLayout,
  isSimilarProductsOnTop,
  showTopBorder = false,
}: ISingleWidgetProps) {
  const WidgetTopRef = isMobile ? WidgetTopMobileRef : WidgetTopDesktopRef;

  if (isMobile && widgetLayout && widgetLayout[widgetType]) {
    const showSeparatorOnTop =
      !isSimilarProductsOnTop && widgetType === WIDGET_TYPES.SIMILAR_PRODUCTS;

    return (
      <React.Fragment key={index}>
        {/** WidgetTopRef is required for view similar click support */}
        {widgetType === WIDGET_TYPES.SIMILAR_PRODUCTS && <WidgetTopRef />}
        <MobileWidgetFeed
          showSeparatorOnTop={showSeparatorOnTop}
          widget={widgetData}
          key={index}
          index={index}
        />
      </React.Fragment>
    );
  }

  return (
    <React.Fragment key={index}>
      {widgetType === WIDGET_TYPES.SIMILAR_PRODUCTS && <WidgetTopRef />}
      <RenderBasicSlider
        isSimilarProductsOnTop={isSimilarProductsOnTop}
        showTopBorder={showTopBorder}
        widget={widgetData}
        i={index}
        isDesktop={!isMobile}
      />
    </React.Fragment>
  );
}

export default memo(SingleWidget);
